import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Badge, Tag, Result, BackTop, Alert, Switch, List, Table, Tooltip, Divider, Checkbox, Radio, Empty, Input, Form, Select, Spin, Avatar, Modal, Tabs, Button, Upload, Row, Col, Card, Icon, Skeleton, message } from 'antd';
import { generateCV, updateDriveFile, uploadDrive, getVacancies, getDrive, newEvent, getContacts, getCandidate, uploadFile, editCandidateNotes } from './../API';
import EditCandidateForm from './../components/editCandidateForm';
import { navigate } from "@reach/router";
import moment from 'moment';
import { flexCenterRight, formItemLayoutForNewEvent, nameStyle, roleStyle } from './../theme';
import { uploadFileValidator, readFileAsync } from './../utils';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faRegistered } from '@fortawesome/free-solid-svg-icons';
import { allNations } from './../utils/countries';
import CustomAvatar from './../components/customAvatar';
import CandidateEventsList from './../components/candidateEventsList';
import { s3, EVENT_TYPE, editorConfig } from './../utils';
import Flag from "react-country-flags";
import InvoicesList from './../components/invoicesList';
import OffersList from './../components/offersList';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { orderBy, uniqBy } = require('lodash');

const { TabPane } = Tabs;
const { Option } = Select;
const { Search } = Input;

const buildEmailTemplate = () => {
  return `
    <p>Hi</p> 
    <p>Hope this finds you well.</p>
    <p>I just come across your profile on E-financial. May I know if you would have interests in job opportunities in XXXXXX please? I am looking for talents focusing on XXXXXX sectors for a Big 4 client in XXXXXX. Do you or any friends have interests in an relocation?</p>
    <p>Looking forward to hearing your thoughts and I am keen to have a further discussion with you at your convenience.</p>
    <p>Thanks</p>
    <p>Lin</p>
  `
}

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    }
  });
}

const buildCVTemplate = async (candidate, showName) => {
  const refSize = 15;
  const nameSize = 14;
  const headerSize = 13;
  const boldSize = 12;
  const defaultSize = 11;

  const buildDateWithIndex = (from, to, index) => {
    let date = '';
    let fromDate;
    let toDate;
    if (from) {
      if (from.includes('-')) {
        fromDate = moment(from).format('MMM YYYY');
      } else {
        fromDate = moment(from).format('YYYY');
      }
    }
    if (to) {
      if (to.includes('-')) {
        toDate = moment(to).format('MMM YYYY');
      } else {
        toDate = moment(to).format('YYYY');
      }
    }

    if (!from && to) {
      date = toDate;
    }

    if (from && !to) {
      if (index === 0) {
        date = `${fromDate} - present`;

      } else {
        date = fromDate;
      }
    }

    if (from && to) {
      date = `${fromDate} - ${toDate}`;
    }
    return date;
  }

  const buildDate = (from, to) => {
    let date = '';
    let fromDate;
    let toDate;
    if (from) {
      if (from.includes('-')) {
        fromDate = moment(from).format('MMM YYYY');
      } else {
        fromDate = moment(from).format('YYYY');
      }
    }
    if (to) {
      if (to.includes('-')) {
        toDate = moment(to).format('MMM YYYY');
      } else {
        toDate = moment(to).format('YYYY');
      }
    }

    if (!from && to) {
      date = toDate;
    }

    if (from && !to) {
      date = fromDate;
    }

    if (from && to) {
      date = `${fromDate} - ${toDate}`;
    }
    return date;
  };

  const getQual = (qual) => {
    const qualArr = qual.text.split('\n');
    let qualArrStr = [];
    qualArrStr.push({text: qualArr[0], alignment: 'left', bold: true, fontSize: boldSize});
    qualArr.splice(0, 1);

    if (qualArr[0] !== '') {
      qualArrStr.push({text: qualArr[0], alignment: 'left'});
      qualArr.splice(0, 1);
    }

    let ulPoint = [];
    for (const point of qualArr) {
      ulPoint.push({text: point, listType: 'point'});
    }

    if (ulPoint.length > 0) {
      qualArrStr.push({
        ul: ulPoint,
        margin: [10, 0, 0, 0],
      })
    }
    
    return qualArrStr;
  }

  const getUniv = (educ) => {
    const educArr = educ.text.split('\n');
    let educArrStr = [];
    educArrStr.push({text: educArr[0], alignment: 'left', bold: true, fontSize: boldSize});
    educArr.splice(0, 1);

    if (educArr[0] !== '') {
      educArrStr.push({text: educArr[0], alignment: 'left'});
      educArr.splice(0, 1);
    }

    let ulPoint = [];
    for (const point of educArr) {
      ulPoint.push({text: point, listType: 'point'});
    }

    if (ulPoint.length > 0) {
      educArrStr.push({
        ul: ulPoint,
        margin: [10, 0, 0, 0],
      })
    }
    
    return educArrStr;
  }

  const getPosition = (work) => {    
    if (work.position.includes(';')) {
      let positionArr = work.position.split(";");
      positionArr = positionArr.map((i) => {
        return {text: i, listType: 'none', bold: true}
      });
      return {
        ul: positionArr,
        margin: [-12, 0, 0, 0],
      }
    }
    return {text: work.position, bold: true, fontSize: boldSize}
  };

  const Linelayout = {
    hLineWidth: function(i, node) {
      return (i === 0 || i === node.table.body.length) ? 0 : 1;
    },
    vLineWidth: function(i, node) {
      return 0;
    }
  }

  const imageURL = 'https://link-global-public.s3.eu-west-1.amazonaws.com/Link-Global.jpg';
  const image = await getBase64FromUrl(imageURL);
  const content = [];
  content.push(
    {
      image: image,
      width: 170,
      height: 30,
    },
  );
  content.push(
    {
      text: '\n',
    },
  );
  content.push({
    text: `Candidate Ref: ${candidate.reference.replace('LG', '')}`,
    fontSize: refSize,
    bold: true,
    alignment: 'center',
    margin: [0, 0, 0, 6],
  });

  if (showName) {
    content.push({
      text: `${candidate.firstname} ${candidate.lastname}`,
      fontSize: nameSize,
      bold: true,
      alignment: 'center',
      margin: [0, 0, 0, 6],
    })
  }

  if (candidate.location) {
    content.push({
      text: [
        'Location: ',
        { text: `${candidate.location}`, bold: false },
      ],
      fontSize: headerSize,
      bold: true,
      alignment: 'left',
    });
  }

  if (candidate.cvBody && candidate.cvBody.description && candidate.cvBody.description.length > 0) {
    content.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              ul: candidate.cvBody.description,
              margin: [10, 15, 10, 15],
            }, 
          ]
        ]
      },
      margin: [0, 12, 0, 12],
    });
  }

  if (candidate.cvBody && !candidate.cvBody.description) {
    content.push(
      {
        text: '\n',
      },
    );
  }

  const orders = [];

  if (candidate.cvBody && candidate.cvBody.qualification && candidate.cvBody.qualification.length > 0) {
    orders.push({
      type: 'qual',
      data: candidate.cvBody.qualification,
    });
  }

  if (candidate.cvBody && candidate.cvBody.education && candidate.cvBody.education.length > 0) {
    orders.push({
      type: 'educ',
      data: candidate.cvBody.education,
    });
  }

  if (candidate.cvBody && candidate.cvBody.work && candidate.cvBody.work.length > 0) {
    orders.push({
      type: 'work',
      data: candidate.cvBody.work,
    });
  }

  if (candidate.cvBody && candidate.cvBody.other1 && candidate.cvBody.other1.length > 0) {
    orders.push({
      type: 'other',
      data: candidate.cvBody.other1,
      title: candidate.cvBody.otherTitle1,
    });
  }

  if (candidate.cvBody && candidate.cvBody.other2 && candidate.cvBody.other2.length > 0) {
    orders.push({
      type: 'other',
      data: candidate.cvBody.other2,
      title: candidate.cvBody.otherTitle2,
    });
  }

  if (candidate.cvBody && candidate.cvBody.other3 && candidate.cvBody.other3.length > 0) {
    orders.push({
      type: 'other',
      data: candidate.cvBody.other3,
      title: candidate.cvBody.otherTitle3,
    });
  }

  for (const each of orders) {
    const line = {
      table: {
        widths: ['*'],
        body: [[" "], [" "]]
      },
      layout: Linelayout,
    };

    if (each.type === 'qual') {
      content.push({
        fontSize: headerSize,
        text: 'Professional Qualifications',
        bold: true,
      });
      for (const qual of candidate.cvBody.qualification) {
        let date = buildDate(qual.from, qual.to);
        content.push({
          table: {
            widths: [150, 300],
            body: [
              [
                {text: `${date}`, bold: true, fontSize: boldSize}, 
                getQual(qual),
              ]
            ]
          },
          layout: Linelayout,
          margin: [-5, 6, 0, 0],
        });
      }
    }

    if (each.type === 'educ') {
      content.push({
        fontSize: headerSize,
        text: 'Educations',
        bold: true,
      });
      for (const educ of candidate.cvBody.education) {
        let date = buildDate(educ.from, educ.to);
        content.push({
          table: {
            widths: [150, 300],
            body: [
              [
                {text: `${date}`, bold: true, fontSize: boldSize}, 
                getUniv(educ),
              ]
            ]
          },
          layout: Linelayout,
          margin: [-5, 6, 0, 0],
        });
      }
    }

    if (each.type === 'work') {
      content.push({
        fontSize: headerSize,
        text: 'Employment Histories',
        bold: true,
      });
      let count = 0;
      for (const work of candidate.cvBody.work) {
        const line = {
          table: {
            widths: ['*'],
            body: [[" "], [" "]]
          },
          layout: Linelayout,
        };
        let date = buildDateWithIndex(work.from, work.to, count);
        content.push({
          table: {
            widths: [150, 300],
            body: [
              [
                {text: `${date}`, bold: true, fontSize: boldSize}, 
                {text: `${work.company}`, bold: true, fontSize: boldSize},
              ]
            ]
          },
          layout: Linelayout,
          margin: [-5, 6, 0, 0],
        });
  
        content.push({
          table: {
            widths: [150, 300],
            body: [
              [
                {text: `Position:`, bold: true, fontSize: boldSize}, 
                getPosition(work),
              ]
            ]
          },
          layout: Linelayout,
          margin: [-5, 0, 0, 6],
        });
  
        if (work.companyDesc) {
          content.push({
            text: work.companyDesc,
            alignment: 'justify',
            color: '#bbb',
            italics: true,
            margin: [0, 0, 0, 6],
          });
        }
  
        if (work.text) {
          content.push({
            text: work.text,
            alignment: 'justify',
            margin: [0, 0, 0, 6],
          });
        }
  
        if (work.textDesc) {
          for (const textDesc of work.textDesc) {

            const ul = {
              text: textDesc.text,
              listType: textDesc.type === 'Level-1' ? "square" : "circle",
              margin: textDesc.type === 'Level-1' ? [20, 0, 0, 6] : [40, 0, 0, 6],
            }

            content.push({
              ul: [ul],
              alignment: 'justify',
            });
          }
        }

        if (work.footer) {
          content.push({
            text: work.footer,
            alignment: 'justify',
            bold: true,
            margin: [0, 0, 0, 6],
          });
        }

        if (count < candidate.cvBody.work.length - 1) {
          content.push(line);
        }
        count = count + 1;

        if (work.space > 0) {
          const arr = Array.from(Array(work.space), (_,x) => x);
          const spaces = arr.map((i) => { return '\n'}).join('');
          content.push({text: spaces})
        }
      }
    }

    if (each.type === 'other') {
      content.push({
        fontSize: headerSize,
        text: each.title,
        bold: true,
        margin: [0, 0, 0, 6],
      });
      for (const item of each.data) {
        const ul = {
          text: item,
          margin: [20, 0, 0, 6],
        }
        content.push({
          ul: [ul],
          alignment: 'justify',
        });
      }
    }

    content.push(line);
  }

  content.push({
    text: 'NOTE THAT ALL OUR CANDIDATES ARE SUBMITTED IN ACCORDANCE WITH OUR STANDARD TERMS AND CONDITIONS OF BUSINESS WHICH HAVE PREVIOUSLY BEEN SENT.',
    bold: true,
    alignment: 'center'
  });

  return {
    pageSize: 'A4',
    defaultStyle: {
      fontSize: defaultSize,
    },
    content,
    footer: function (currentPage, pageCount) {
      return { 
        text: "Page " + currentPage.toString() + ' of ' + pageCount + ' (Link Global)', 
        alignment: 'right', 
        fontSize: 10, 
        margin: [0, 20, 20, 0],
        width: '*',
      };
  },
  }
}

function Candidate(props) {
  const nations = allNations();

  const session = useMappedState(state => state.session);
  const candidate = useMappedState(state => state.candidate);
  const candidateContactList = useMappedState(state => state.candidateContactList);

  const dispatch = useDispatch();

  const [pdfURL, setPdfURL] = useState(null);

  const [activeTab, setActiveTab] = useState(1);

  const [updateFileDetail, setUpdateFileDetail] = useState(null);
  const [showUpdateFileModal, setShowUpdateFileModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [eventReloading, setEventReloading] = useState(false);

  const [showCVModal, setShowCVModal] = useState(false);

  const [loading, setLoading] = useState(true);
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notes, setNotes] = useState(null);
  const [notesLoading, setNotesLoading] = useState(false);

  const [fileSearch, setFileSearch] = useState("");
  const [files, setFiles] = useState([]);
  const [lgFiles, setLgFiles] = useState([]);

  const [driveRefetching, setDriveRefetching] = useState(false);

  const eventsTypeArr = orderBy(Object.keys(EVENT_TYPE).map(e => {
    return EVENT_TYPE[e]
  }));

  const [eventType, setEventType] = useState(EVENT_TYPE.all.name);

  const [showCreateEventModal, setShowCreateEventModal] = useState(false);
  const [contactListForNewEvent, setContactListForNewEvent] = useState([]);

  const [vacancies, setVacancies] = useState([]);

  useEffect(() => {
    async function fetchData() {
      dispatch({ type: "CLEAR_CANDIDATE" });
      dispatch({ type: "SET_CANDIDATE_CONTACTS_LIST_SELECTION", payload: 'all' });
      const response = await getCandidate(session.authToken, props.id);
      if (response.data.responseCode === 0) {
        setNotes(response.data.candidate.notes);
        dispatch({ type: "INIT_CANDIDATE", payload: response.data.candidate });

        const dataResponse = await Promise.all([
          getDrive(session.authToken, response.data.candidate.driveFolderID),
          getDrive(session.authToken, process.env.REACT_APP_LG_DRIVE),
          getContacts(session.authToken),
          getVacancies(session.authToken)
        ]);

        //construct all available contacts from events
        const allContacts = uniqBy(response.data.candidate.events.filter(i => i.contact).map(x => x.contact), 'id');
        dispatch({
          type: "SET_CANDIDATE_CONTACTS_LIST",
          payload: allContacts.map(i => {
            return {
              ...i,
              ...{ avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg` }
            }
          })
        });

        setFiles(dataResponse[0].data.data);
        setLgFiles(dataResponse[1].data.data);
        //fetch all contacts from system and used in create new event contact selection
        setContactListForNewEvent(dataResponse[2].data.contacts);
        // fetch all vacancies
        setVacancies(dataResponse[3].data.vacancies);

        setLoading(false);
      }
      else {
        navigate(`/candidates`);
        message.error(response.data.message);
      }
    }
    dispatch({ type: "SET_INDEX", payload: "5" });
    fetchData();
    // eslint-disable-next-line
  }, []);

  const cardTitle = (candidate) => {
    const countryCode = nations.find(i => i.name === candidate.country);
    return (
      <center>
        {
          !avatarLoading ?
            <CustomAvatar
              colourCode={candidate.firstname.charAt(0).toLowerCase()}
              char={`${candidate.firstname.charAt(0).toUpperCase()}${candidate.lastname.charAt(0).toUpperCase()}`}
              charSize={30}
              size={86}
              src={candidate.avatar}
            />
            :
            <Avatar size={86} style={{ backgroundColor: '#eeeeee' }}>
              <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} />} />
            </Avatar>
        }
        <>
        <div style={{ marginTop: "15px" }}>
          <p style={nameStyle}>
            {candidate.salutation} {candidate.firstname} {candidate.lastname}
          </p>

          {
            candidate.country && candidate.country !== "" ?
              <div>
                <Flag country={countryCode.code} asSquare={true} style={{ width: '40px', height: '30px' }} />
              </div>
              :
              null
          }

          {
            candidate.linkedin && candidate.linkedin !== "" ?
              <React.Fragment>
                <br />
                <p style={roleStyle} onClick={() => {
                  window.open(candidate.linkedin, '_blank');
                }}>
                  <span style={{ cursor: "pointer" }}>go to linkedin</span>
                </p>
              </React.Fragment>
              :
              null
          }
          
          {
            candidate.bothSide ? (
              <React.Fragment>
                <p>
                <center>
                  <Tooltip title="This candidate is contact as well">
                    <Tag color="#0D98BA">Contact</Tag>
                  </Tooltip>
                </center>
                </p>
              </React.Fragment>
            ) : null
          }

          <Upload
            beforeUpload={(file) => {
              return uploadFileValidator(message, file, ['image/jpeg'], 4);
            }}
            showUploadList={false}
            customRequest={(e) => {
              setAvatarLoading(true);
              var reader = new FileReader();
              reader.readAsDataURL(e.file);

              reader.onload = function () {
                const imageData = reader.result.replace("data:image/jpeg;base64,", "")
                uploadFile(session.authToken,
                  { file: imageData, name: `avatar/candidate/${candidate.id}.jpeg`, acl: 'public-read' }).then(x => {
                    setAvatarLoading(false);
                    e.onSuccess();
                    dispatch({ type: "UPDATE_CANDIDATE_AVATAR" });
                  })
              }
            }}>
            <Button size="small">
              {avatarLoading ? <Icon type="loading" /> : <Icon type="upload" />}Upload Avatar
            </Button>
          </Upload>

        </div>
        </>
      </center>
    )
  }

  const eventTypeSelection = [];
  for (let i = 0; i < eventsTypeArr.length; i++) {
    eventTypeSelection.push(
      <Option key={eventsTypeArr[i].name} value={eventsTypeArr[i].name}>
        {eventsTypeArr[i].text}
      </Option>
    )
  }

  const contactSelection = [
    <Option key={'all'} value={'all'}>All</Option>,
    <Option key={'no-contact'} value={'no-contact'}>No Contact</Option>
  ];
  for (let i = 0; i < candidateContactList.contacts.length; i++) {
    contactSelection.push(
      <Option key={candidateContactList.contacts[i].id} value={candidateContactList.contacts[i].id}>
        <CustomAvatar
          colourCode={candidateContactList.contacts[i].firstname.charAt(0).toLowerCase()}
          char={`${candidateContactList.contacts[i].firstname.charAt(0).toUpperCase()}${candidateContactList.contacts[i].lastname.charAt(0).toUpperCase()}`}
          charSize={11}
          size={26}
          src={candidateContactList.contacts[i].avatar}
        />
        &nbsp;&nbsp;{candidateContactList.contacts[i].firstname} {candidateContactList.contacts[i].lastname}
      </Option>
    )
  }

  const getEventsList = (eventType, contact, data) => {
    let events = data;

    if (eventType !== "all" && contact !== 'all' && contact !== 'no-contact') {
      events = data.filter(i => i.type === eventType && i.contact && i.contact.id === contact)
    }

    if (eventType !== "all" && contact !== 'all' && contact === 'no-contact') {
      events = data.filter(i => i.type === eventType && !i.contact)
    }

    if (eventType !== "all" && contact === 'all' && contact === 'no-contact') {
      events = data.filter(i => i.type === eventType)
    }

    if (eventType === "all" && contact !== 'all' && contact !== 'no-contact') {
      events = data.filter(i => i.contact && i.contact.id === contact)
    }

    if (eventType === "all" && contact !== 'all' && contact === 'no-contact') {
      events = data.filter(i => !i.contact)
    }

    if (eventType !== "all" && contact === 'all' && contact !== 'no-contact') {
      events = data.filter(i => i.type === eventType)
    }

    return events
  }

  const reloadCandidate = async () => {
    setEventReloading(true);

    const response = await getCandidate(session.authToken, props.id);

    if (response.data.responseCode === 0) {
      setNotes(response.data.candidate.notes);
      dispatch({ type: "INIT_CANDIDATE", payload: response.data.candidate });

      //re-construct all available contacts from events
      const allContacts = uniqBy(response.data.candidate.events.filter(i => i.contact).map(x => x.contact), 'id');
      dispatch({
        type: "SET_CANDIDATE_CONTACTS_LIST",
        payload: allContacts.map(i => {
          return {
            ...i,
            ...{ avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg` }
          }
        })
      });
    }
    setEventReloading(false);
  }

  const NewEvent = ({ form }) => {
    const { getFieldDecorator } = form;

    const [createEventType, setCreateEventType] = useState(null);

    const [showEmailPanel, setShowEmailPanel] = useState(false);

    const [contactDocSearch, setContactDocSearch] = useState("");
    const [candidateDocSearch, setCandidateDocSearch] = useState("");

    const [contactDocList, setContactDocList] = useState([]);
    const [candidateDocList, setCandidateDocList] = useState([]);

    const [generalFiles, setGeneralFiles] = useState([]);
    const [candidateFiles, setCandidateFiles] = useState([]);

    const [contactFiles, setContactFiles] = useState([]);
    const [contactFilesLoading, setContactFilesLoading] = useState(false);

    const [showContactDocs, setShowContactDocs] = useState(false);
    const [showCandidateDocs, setShowCandidateDocs] = useState(false);

    const [contactAttachment, setContactAttachment] = useState([]);
    const [candidateAttachment, setCandidateAttachment] = useState([]);

    const [eventBody, setEventBody] = useState(null);
    const [contactEmailBody, setContactEmailBody] = useState(null);
    const [candidateEmailBody, setCandidateEmailBody] = useState(buildEmailTemplate());

    const [writingPanel, setWritingPanel] = useState('record');
    const [newEventLoading, setNewEventLoading] = useState(false);

    const [contactEmailDetail, setContactEmailDetail] = useState(null);

    const eventsTypesForNewEvent = eventsTypeArr.filter(
      i => i.name !== 'all' && 
      i.name !== 'bulk-emails' && 
      i.name !== 'vacancy' && 
      i.name !== 'check-payment' &&
      i.name !== 'send-invoice');

    const eventTypeSelectionForNewEvent = [];
    for (let i = 0; i < eventsTypesForNewEvent.length; i++) {
      eventTypeSelectionForNewEvent.push(
        <Option key={eventsTypesForNewEvent[i].name} value={eventsTypesForNewEvent[i].name}>
          {eventsTypesForNewEvent[i].text}
        </Option>
      )
    }

    const contactSelectionForNewEvent = [
      <Option label="Not Select" key="n/s" value="">Not Select</Option>
    ];
    for (let i = 0; i < contactListForNewEvent.length; i++) {
      contactSelectionForNewEvent.push(
        <Option
          label={`${contactListForNewEvent[i].firstname} ${contactListForNewEvent[i].lastname}`}
          key={contactListForNewEvent[i].id}
          value={contactListForNewEvent[i].id}>
          <CustomAvatar
            style={{ marginTop: '-3px' }}
            colourCode={contactListForNewEvent[i].firstname.charAt(0).toLowerCase()}
            char={`${contactListForNewEvent[i].firstname.charAt(0).toUpperCase()}${contactListForNewEvent[i].lastname.charAt(0).toUpperCase()}`}
            charSize={11}
            size={26}
            src={contactListForNewEvent[i].avatar}
          />
          &nbsp;&nbsp;{contactListForNewEvent[i].firstname} {contactListForNewEvent[i].lastname}
        </Option>
      )
    }

    const handleOnClickSubmitNewEvent = async () => {
      const formResult = await form.validateFields();

      let params = {
        type: formResult.eventtype,
        candidateID: candidate.id,
      }

      if (formResult.vacancyRef) {
        params = {
          ...params,
          ...{
            vacancyRef: formResult.vacancyRef
          }
        }
      }

      if (formResult.submitType === 'record') {
        params = { ...params, ...{ submitType: 'record', body: eventBody ? eventBody : "" } }
        if (formResult.contact) {
          params = { ...params, ...{ contactID: formResult.contact } }
        }
      }

      if (formResult.submitType === 'email') {

        const candidateFileList = [];
        for (const each of candidateAttachment) {
          const file = await readFileAsync(each)
          candidateFileList.push({
            name: each.name,
            type: each.type,
            data: file.replace(/data:.+,/, ""),
          })
        }

        const candidateDriveList = [];
        for (const each of candidateDocList) {
          candidateDriveList.push({
            id: each.id,
            name: each.name,
            type: each.mimeType,
            icon: each.iconLink
          })
        }

        params = {
          ...params,
          ...{
            submitType: 'email',
            candidateEmail: formResult.candidate_email,
            candidateEmail1: formResult.candidate_email1 ? formResult.candidate_email1 : false,
            candidateEmail2: formResult.candidate_email2 ? formResult.candidate_email2 : false,
            candidateEmailSubject: formResult.candidate_email_subject,
            candidateEmailBody: candidateEmailBody ? candidateEmailBody : "",
            candidateEmailFiles: candidateFileList,
            candidateEmailDrives: candidateDriveList,
          }
        }

        if (formResult.contact) {

          params = { ...params, ...{ contactID: formResult.contact } }

          if (showEmailPanel) {
            const contactFileList = [];
            for (const each of contactAttachment) {
              const file = await readFileAsync(each)
              contactFileList.push({
                name: each.name,
                type: each.type,
                data: file.replace(/data:.+,/, ""),
              })
            }

            const contactDriveList = [];
            for (const each of contactDocList) {
              contactDriveList.push({
                id: each.id,
                name: each.name,
                type: each.mimeType,
                icon: each.iconLink
              })
            }

            params = {
              ...params,
              ...{
                contactEmail: formResult.contact_email,
                contactEmail1: formResult.contact_email1 ? formResult.contact_email1 : false,
                contactEmail2: formResult.contact_email2 ? formResult.contact_email2 : false,
                contactCC: formResult.contact_cc ? formResult.contact_cc : [],
                contactBCC: formResult.contact_bcc ? formResult.contact_bcc : [],
                contactEmailSubject: formResult.contact_email_subject,
                contactEmailBody: contactEmailBody ? contactEmailBody : "",
                contactEmailFiles: contactFileList,
                contactEmailDrives: contactDriveList,
              }
            }
          }
          else {
            params = {
              ...params,
              ...{ contactEmailDoNotSend: true }
            }
          }
        }
      }

      setNewEventLoading(true);
      const result = await newEvent(session.authToken, params);

      if (result.data.responseCode === 0) {
        reloadCandidate();
        setNewEventLoading(false);
        setShowCreateEventModal(false);
        message.success(result.data.message);
      }
      else {
        setNewEventLoading(false);
        dispatch({ type: "OPEN_MSG_MODAL", payload: result.data.message });
      }
    }

    const EmailCheckboxs = () => {
      return (
        <React.Fragment>
          <Divider />
          <div>To Candidate: <b>{candidate.firstname} {candidate.lastname}</b></div>
          <Row>
            <Col span={8}>
              <Form.Item>
                {getFieldDecorator('candidate_email', {
                  initialValue: true,
                  valuePropName: 'checked'
                })(<Checkbox disabled={true}>{candidate.email}</Checkbox>)}
              </Form.Item>
            </Col>
            <Col span={8}>
              {
                candidate.email1 ?
                  <Form.Item>
                    {getFieldDecorator('candidate_email1', {
                      initialValue: true,
                      valuePropName: 'checked'
                    })(<Checkbox>{candidate.email1}</Checkbox>)}
                  </Form.Item>
                  :
                  null
              }
            </Col>
            <Col span={8}>
              {
                candidate.email2 ?
                  <Form.Item>
                    {getFieldDecorator('candidate_email2', {
                      initialValue: true,
                      valuePropName: 'checked'
                    })(<Checkbox>{candidate.email2}</Checkbox>)}
                  </Form.Item>
                  :
                  null
              }
            </Col>
          </Row>
        </React.Fragment>
      )
    }

    const ContactEmailCheckboxs = () => {
      const c = contactListForNewEvent.find(i => i.id === contactEmailDetail);
      return (
        <React.Fragment>
          <Divider />
          <div>To Contact: <b>{c.firstname} {c.lastname}</b></div>
          <Row>
            <Col span={8}>
              <Form.Item>
                {getFieldDecorator('contact_email', {
                  initialValue: true,
                  valuePropName: 'checked'
                })(<Checkbox disabled={true}>{c.email}</Checkbox>)}
              </Form.Item>
            </Col>
            <Col span={8}>
              {
                c.email1 ?
                  <Form.Item>
                    {getFieldDecorator('contact_email1', {
                      initialValue: true,
                      valuePropName: 'checked'
                    })(<Checkbox>{c.email1}</Checkbox>)}
                  </Form.Item>
                  :
                  null
              }
            </Col>
            <Col span={8}>
              {
                c.email2 ?
                  <Form.Item>
                    {getFieldDecorator('contact_email2', {
                      initialValue: true,
                      valuePropName: 'checked'
                    })(<Checkbox>{c.email2}</Checkbox>)}
                  </Form.Item>
                  :
                  null
              }
            </Col>
          </Row>
        </React.Fragment>
      )
    }

    const ContactDriveFile = ({ data }) => {
      return (
        <div style={{ width: '100%', marginBottom: '8px' }}>
          <Row style={{ backgroundColor: '#ECF7FA' }}>
            <Col span={23}>
              <img
                style={{
                  marginLeft: "5px",
                  position: "relative",
                }}
                src={data.iconLink}
                alt={data.name}
              />
              &nbsp;
              {data.name}
            </Col>
            <Col span={1}>
              <div style={flexCenterRight}>
                <Icon
                  onClick={() => {
                    setContactDocList(contactDocList.filter(i => i.id !== data.id))
                  }}
                  style={{
                    cursor: "pointer",
                    marginTop: "4px",
                    marginRight: "5px",
                    position: "relative",
                  }}
                  type="delete" />
              </div>
            </Col>
          </Row>
        </div>
      )
    }

    const renderContactEmailPanel = () => {
      const c = contactListForNewEvent.find(i => i.id === contactEmailDetail);
      const data = contactListForNewEvent.filter(k => k.client.id === c.client.id && c.id !== k.id);

      return (
        <React.Fragment>
          <Row>
            <Col span={10}>
              <Form.Item {...{
                labelCol: { span: 2 },
                wrapperCol: { span: 22 },
              }} label="CC">
                {getFieldDecorator('contact_cc', {
                })(
                  <Select
                    optionFilterProp={'label'}
                    mode="multiple"
                    disabled={newEventLoading}
                    placeholder="CC"
                    style={{ width: 250 }}
                  >
                    {
                      data.map(i =>
                        <Option
                          label={`${i.firstname} ${i.lastname}`}
                          value={i.id}
                          key={i.id}>
                          {`${i.firstname} ${i.lastname}`}
                        </Option>
                      )
                    }
                  </Select>
                )}
              </Form.Item>
            </Col>

            <Col span={1} />

            <Col span={10}>
              <Form.Item {...{
                labelCol: { span: 3 },
                wrapperCol: { span: 21 },
              }} label="BCC">
                {getFieldDecorator('contact_bcc', {
                })(
                  <Select
                    optionFilterProp={'label'}
                    mode="multiple"
                    disabled={newEventLoading}
                    placeholder="BCC"
                    style={{ width: 250 }}
                  >
                    {
                      data.map(i =>
                        <Option
                          label={`${i.firstname} ${i.lastname}`}
                          value={i.id}
                          key={i.id}>
                          {`${i.firstname} ${i.lastname}`}
                        </Option>
                      )
                    }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <Upload {...{
                accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
                multiple: true,
                showUploadList: true,
                onRemove: file => {
                  setContactAttachment(contactAttachment.filter(i => i.uid !== file.uid));
                },
                beforeUpload: (_, fileList) => {
                  setContactAttachment([...contactAttachment, ...fileList])
                  return false;
                },
                contactAttachment,
              }}>
                <Tooltip placement="right" title={"Allowed file types are image, pdf, doc, docx, xls, xlsx, ppt, pptx"}>
                  <Button disabled={newEventLoading} >
                    <FontAwesomeIcon icon={faPaperclip} />&nbsp;&nbsp;Attachments
                  </Button>
                </Tooltip>
              </Upload>
              <br />
            </Col>

            <Col span={1} />

            <Col span={10}>
              <Tooltip placement="right" title={"Allowed attachment files from Google Drive"}>
                <Button onClick={() => {
                  setShowContactDocs(true);
                }}
                  disabled={newEventLoading || contactFilesLoading} >
                  {
                    contactFilesLoading ?
                      <Icon type="loading" />
                      :
                      <FontAwesomeIcon icon={faFolderOpen} />
                  }
                  &nbsp;&nbsp;Documents
                </Button>
              </Tooltip>
              {
                contactDocList.length > 0 ?
                  <div style={{ marginTop: '8px', marginBottom: '22px' }}>
                    {
                      contactDocList.map((i, k) => (
                        <ContactDriveFile key={k} data={i} />
                      ))
                    }
                  </div>
                  :
                  null
              }
            </Col>
          </Row>

          <div>
            <Form.Item>
              {getFieldDecorator('contact_email_subject', {
                rules: [{ required: true, message: 'Please input subject!' }],
              })(
                <Input autoComplete="off" placeholder="Subject" disabled={newEventLoading} />
              )}
            </Form.Item>
          </div>

          <Row>
            <Col span={24}>
              <CKEditor
                disabled={newEventLoading}
                value={contactEmailBody}
                data={contactEmailBody}
                editor={Editor}
                config={editorConfig}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setContactEmailBody(data);
                }}
              />
            </Col>
          </Row>
        </React.Fragment>
      )
    }

    const CandidateDriveFile = ({ data }) => {
      return (
        <div style={{ width: '100%', marginBottom: '8px' }}>
          <Row style={{ backgroundColor: '#ECF7FA' }}>
            <Col span={23}>
              <img
                style={{
                  marginLeft: "5px",
                  position: "relative",
                }}
                src={data.iconLink}
                alt={data.name}
              />
              &nbsp;
              {data.name}
            </Col>
            <Col span={1}>
              <div style={flexCenterRight}>
                <Icon
                  onClick={() => {
                    setCandidateDocList(candidateDocList.filter(i => i.id !== data.id))
                  }}
                  style={{
                    cursor: "pointer",
                    marginTop: "4px",
                    marginRight: "5px",
                    position: "relative",
                  }}
                  type="delete" />
              </div>
            </Col>
          </Row>
        </div>
      )
    }

    const renderEmailPanel = () => {
      return (
        <React.Fragment>
          <Form.Item hidden={true}>
            {getFieldDecorator('submitType', {
              initialValue: "email"
            })(
              <Input autoComplete="off" disabled={true} />
            )}
          </Form.Item>
          <EmailCheckboxs />
          <Row>
            <Col span={10}>
              <Upload {...{
                accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
                multiple: true,
                showUploadList: true,
                onRemove: file => {
                  setCandidateAttachment(candidateAttachment.filter(i => i.uid !== file.uid));
                },
                beforeUpload: (_, fileList) => {
                  setCandidateAttachment([...candidateAttachment, ...fileList])
                  return false;
                },
                candidateAttachment,
              }}>
                <Tooltip placement="right" title={"Allowed file: image, pdf, doc, docx, xls, xlsx, ppt, pptx"}>
                  <Button disabled={newEventLoading} >
                    <FontAwesomeIcon icon={faPaperclip} />&nbsp;&nbsp;Attachments
                  </Button>
                </Tooltip>
              </Upload>
              <br />
            </Col>

            <Col span={1} />

            <Col span={10}>
              <Tooltip placement="right" title={"Allowed attachment files from Google Drive"}>
                <Button onClick={() => {
                  setGeneralFiles(lgFiles);
                  setCandidateFiles(files);
                  setShowCandidateDocs(true);
                }}
                  disabled={newEventLoading || contactFilesLoading} >
                  {
                    contactFilesLoading ?
                      <Icon type="loading" />
                      :
                      <FontAwesomeIcon icon={faFolderOpen} />
                  }
                  &nbsp;&nbsp;Documents
                </Button>
              </Tooltip>
              {
                candidateDocList.length > 0 ?
                  <div style={{ marginTop: '8px', marginBottom: '22px' }}>
                    {
                      candidateDocList.map((i, k) => (
                        <CandidateDriveFile key={k} data={i} />
                      ))
                    }
                  </div>
                  :
                  null
              }
            </Col>

          </Row>

          <Row>
            <Col span={2}>
              <div style={{marginTop: '4px'}}>
                <Tooltip title="Clear Email Body">
                  <Button onClick={() => {
                    setCandidateEmailBody('');
                  }}><Icon type="delete" /></Button>
                </Tooltip>
              </div>
            </Col>
            <Col span={22}>
              <Form.Item>
                {getFieldDecorator('candidate_email_subject', {
                  rules: [{ required: true, message: 'Please input subject!' }],
                })(
                  <Input autoComplete="off" placeholder="Subject" disabled={newEventLoading} />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <CKEditor
                disabled={newEventLoading}
                value={candidateEmailBody}
                data={candidateEmailBody}
                editor={Editor}
                config={editorConfig}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setCandidateEmailBody(data);
                }}
              />
            </Col>
          </Row>

          {
            contactEmailDetail ?
              showEmailPanel ?
                <ContactEmailCheckboxs />
                :
                null
              :
              null
          }

          {
            contactEmailDetail ?
              showEmailPanel ?
                renderContactEmailPanel()
                :
                null
              :
              null
          }

        </React.Fragment>
      )
    }

    const handleOnSelectContact = async (value) => {
      if (value === "") {
        setShowEmailPanel(false);
        setContactEmailDetail(null);
        setContactFiles([]);
        setContactDocList([]);
        setCandidateDocList([]);
      }
      else {
        setContactDocList([]);
        setCandidateDocList([]);
        setContactFiles([]);
        setContactEmailDetail(value);
        const c = contactListForNewEvent.find(i => i.id === value);
        setContactFilesLoading(true);
        const responseDrive = await getDrive(session.authToken, c.client.driveFolderID);
        setContactFiles(responseDrive.data.data);
        setContactFilesLoading(false);
      }
    }

    return (
      <Modal
        centered={true}
        title="Create New Event"
        closable={false}
        visible={showCreateEventModal}
        width="90%"
        footer={[
          <Button disabled={newEventLoading} key="cancel" onClick={() => {
            setShowCreateEventModal(false);
          }}>
            <Icon type="close" />
            Cancel
          </Button>,
          <Button key="create" type="primary" onClick={handleOnClickSubmitNewEvent}>
            {newEventLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        ]}
      >
        <React.Fragment>

          <Modal
            centered={true}
            title="Select Contact Documents"
            closable={false}
            visible={showContactDocs}
            width={800}
            footer={[
              <Button key="cancel" onClick={() => {
                setShowContactDocs(false)
                setContactDocSearch("");
              }}>
                <Icon type="close" />
                Close
              </Button>
            ]}
          >
            <div style={{ maxHeight: "415px" }}>
              <div>
                <Search
                  value={contactDocSearch}
                  placeholder="Search"
                  onChange={e => setContactDocSearch(e.target.value)}
                  style={{ width: 200 }}
                />
              </div>

              <br />

              <List
                style={{
                  maxHeight: "300px",
                  overflow: "auto"
                }}
                size="small"
                pagination={false}
                bordered
                dataSource={
                  contactDocSearch === '' ?
                    [...lgFiles, ...files, ...contactFiles]
                    :
                    [...lgFiles, ...files, ...contactFiles].filter(i => i.name.toLowerCase().includes(contactDocSearch.toLowerCase()))
                }
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      <Row>
                        {
                          [...lgFiles, ...files, ...contactFiles].filter(i => i.starred).length > 0 ?
                            <Col span={1}>
                              {
                                item.starred ?
                                  <FontAwesomeIcon style={{ color: "red" }} icon={faStar} />
                                  :
                                  null
                              }
                            </Col>
                            :
                            null
                        }
                        <Col span={[...lgFiles, ...files, ...contactFiles].filter(i => i.starred).length > 0 ? 18 : 19}>
                          <div>
                            <img
                              src={item.iconLink}
                              alt={item.name}
                            />
                            &nbsp;
                            {item.name}
                          </div>
                        </Col>
                        <Col span={4}>
                          {
                            item.parents[0] === process.env.REACT_APP_LG_DRIVE ? (
                              <center><Tag>Link Global Folder</Tag></center>
                            ) : null
                          }
                        </Col>
                        <Col span={1}>
                          <div style={flexCenterRight}>
                            {
                              contactDocList.find(i => i.id === item.id) ?
                                <Checkbox checked={true} onClick={() => {
                                  setContactDocList(
                                    contactDocList.filter(i => i.id !== item.id)
                                  )
                                }} />
                                :
                                <Checkbox checked={false} onClick={() => {
                                  setContactDocList([...contactDocList, ...[item]])
                                }} />
                            }
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </Modal>

          <Modal
            centered={true}
            title="Select Candidate Documents"
            closable={false}
            visible={showCandidateDocs}
            width={800}
            footer={[
              <Button key="cancel" onClick={() => {
                setShowCandidateDocs(false);
                setTimeout(() => {
                  setGeneralFiles([]);
                  setCandidateFiles([]);
                  setCandidateDocSearch("");
                }, 250);
              }}>
                <Icon type="close" />
                Close
              </Button>
            ]}
          >
            <div style={{ maxHeight: "415px" }}>
              <div>
                <Search
                  value={candidateDocSearch}
                  placeholder="Search"
                  onChange={e => setCandidateDocSearch(e.target.value)}
                  style={{ width: 200 }}
                />
              </div>

              <br />

              <List
                style={{
                  maxHeight: "300px",
                  overflow: "auto"
                }}
                size="small"
                pagination={false}
                bordered
                dataSource={
                  candidateDocSearch === '' ?
                    [...generalFiles, ...candidateFiles, ...contactFiles]
                    :
                    [...generalFiles, ...candidateFiles, ...contactFiles].filter(i => i.name.toLowerCase().includes(candidateDocSearch.toLowerCase()))
                }
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      <Row>
                        {
                          [...generalFiles, ...candidateFiles, ...contactFiles].filter(i => i.starred).length > 0 ?
                            <Col span={1}>
                              {
                                item.starred ?
                                  <FontAwesomeIcon style={{ color: "red" }} icon={faStar} />
                                  :
                                  null
                              }
                            </Col>
                            :
                            null
                        }
                        <Col span={[...generalFiles, ...candidateFiles, ...contactFiles].filter(i => i.starred).length > 0 ? 18 : 19}>
                          <div>
                            <img
                              src={item.iconLink}
                              alt={item.name}
                            />
                            &nbsp;
                            {item.name}
                          </div>
                        </Col>
                        <Col span={4}>
                          {
                            item.parents[0] === process.env.REACT_APP_LG_DRIVE ? (
                              <center><Tag>Link Global Folder</Tag></center>
                            ) : null
                          }
                        </Col>
                        <Col span={1}>
                          <div style={flexCenterRight}>
                            {
                              candidateDocList.find(i => i.id === item.id) ?
                                <Checkbox checked={true} onClick={() => {
                                  setCandidateDocList(
                                    candidateDocList.filter(i => i.id !== item.id)
                                  )
                                }} />
                                :
                                <Checkbox checked={false} onClick={() => {
                                  setCandidateDocList([...candidateDocList, ...[item]])
                                }} />
                            }
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </Modal>

          <Row>
            <Col span={12}>
              <Form.Item {...formItemLayoutForNewEvent} label="Event Type">
                {getFieldDecorator('eventtype', {
                  rules: [{ required: true, message: 'Please select event type!' }],
                })(
                  <Select
                    disabled={newEventLoading}
                    placeholder="Event Type"
                    style={{ width: 220 }}
                    onChange={(value) => {
                      setCreateEventType(value);
                    }}
                  >
                    {eventTypeSelectionForNewEvent}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              {
                createEventType !== 'interview-follow-up' ? (
                  <Form.Item {...formItemLayoutForNewEvent} label="Contact">
                    {getFieldDecorator('contact', {
                      initialValue: '',
                    })(
                      <Select
                        onChange={(value) => { handleOnSelectContact(value) }}
                        optionFilterProp={'label'}
                        showSearch={true}
                        disabled={newEventLoading}
                        placeholder="Contact"
                        style={{ width: 200 }}
                      >
                        {contactSelectionForNewEvent}
                      </Select>
                    )}
                  </Form.Item>
                ) : null
              }
            </Col>
          </Row>

          <Row>
            {
              createEventType === 'interview-follow-up' ? (
                <Form.Item>
                  {getFieldDecorator('vacancyRef', {
                  })(
                    <Select
                      optionFilterProp={'label'}
                      showSearch={true}
                      disabled={newEventLoading}
                      placeholder="Please Select Vacancy"
                      style={{ width: '100%' }}
                    >
                      {
                        vacancies.map(i => (
                          <Option label={i.title} key={i.id} value={i.id}>
                            {i.title}&nbsp;&nbsp;<Tag color="#72A0C1">{i.client_docs.name}</Tag>
                          </Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              ) : null
            }
          </Row>

          <Row>
            <Col span={12}>
              <div style={{ marginBottom: '10px' }}>
                <Radio.Group onChange={(e) => {
                  if (e.target.value === 'email') {
                    setEventBody(null)
                  }
                  if (e.target.value === 'record') {
                    setContactDocList([])
                    setCandidateDocList([])
                    setContactAttachment([])
                    setCandidateAttachment([])
                    setContactEmailBody(null)
                    setCandidateEmailBody(null)
                  }
                  setWritingPanel(e.target.value)
                }} value={writingPanel}>
                  <Radio value={"record"}>Record</Radio>
                  <Radio value={"email"} disabled={createEventType === 'interview-follow-up'}>Email</Radio>
                </Radio.Group>
              </div>
            </Col>

            <Col span={12}>
              {
                writingPanel === "email" && contactEmailDetail !== null ?
                  <div>
                    <Switch defaultChecked={showEmailPanel} onChange={() => {
                      setShowEmailPanel(!showEmailPanel)
                    }} />
                    &nbsp;<i style={{ color: "#bbb" }}>want to send email to contact?</i>
                  </div>
                  :
                  null
              }
            </Col>
          </Row>

          {
            writingPanel === 'record' ?
              <React.Fragment>
                <Form.Item hidden={true}>
                  {getFieldDecorator('submitType', {
                    initialValue: "record"
                  })(
                    <Input autoComplete="off" disabled={true} />
                  )}
                </Form.Item>
                <Row>
                  <Col span={24}>
                    <CKEditor
                      disabled={newEventLoading}
                      value={eventBody}
                      data={eventBody}
                      editor={Editor}
                      config={editorConfig}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEventBody(data);
                      }}
                    />
                  </Col>
                </Row>
              </React.Fragment>
              :
              renderEmailPanel()
          }
        </React.Fragment>
      </Modal>
    )
  }

  const NewEventForm = Form.create({ name: 'new-event' })(NewEvent);

  const CVModal = () => {
    const ref = candidate.reference.replace('LG', '');
    const name = `${candidate.firstname} ${candidate.lastname}`;

    const default_ref_file_name = `Ref ${ref}`;
    const default_ref_name_file_name = `Ref ${ref} - ${name}`;

    const [cvLoading, setCvLoading] = useState(false);

    const [showName, setShowName] = useState(false);
    const [showCustomFile, setShowCustomFile] = useState(false);
    const [customFileName, setCustomeFileName] = useState(default_ref_file_name);

    return (
      <Modal
        centered={true}
        title="Generate Candidate CV"
        closable={false}
        visible={showCVModal}
        width={800}
        footer={[
          <Button disabled={cvLoading} key="cancel" onClick={() => {
            setShowCVModal(false);
          }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button disabled={cvLoading || customFileName.trim().length === 0} type="primary" key="generate" onClick={async () => {
            setCvLoading(true);
            const template = await buildCVTemplate(candidate, showName);
            pdfMake.createPdf(template).getBase64(async (base64data) => {
              const result = await generateCV(session.authToken, {
                id: candidate.id,
                cv: base64data,
                fileName: customFileName,
              });
              if (result && result.data && result.data && result.data.data.statusText) {
                const responseDrive = await getDrive(session.authToken, candidate.driveFolderID);
                setFiles(responseDrive.data.data);
                setCvLoading(false);
                message.success('Candidate CV upload');
                setShowCVModal(false);
              } else {
                setCvLoading(false);
                message.error('Something wrong with candidate CV upload, please contact with Admin');
              }
            });
          }}>
            {cvLoading ? <Icon type="loading" /> : <Icon type="cloud-upload" />}
            Generate Candidate CV
          </Button>
        ]}
      >
        <div>
          <Alert message={
            <>
              <div>Warning: New file will replace old file if they have same file name.</div>
            </>
          } type="warning" showIcon />
          <br />
          <Checkbox checkd={showName} onClick={() => {
            setShowName(!showName);
            const x = !showName;
            if (x && showCustomFile) {
              setCustomeFileName("");
            }
            if (x && !showCustomFile) {
              setCustomeFileName(default_ref_name_file_name);
            }
            if (!x && showCustomFile) {
              setCustomeFileName("");
            }
            if (!x && !showCustomFile) {
              setCustomeFileName(default_ref_file_name);
            }
          }}>Show Candidate Name in CV</Checkbox>
          <Checkbox checkd={showCustomFile} onClick={() => {
            setShowCustomFile(!showCustomFile);
            const y = !showCustomFile;
            if (showName && y) {
              setCustomeFileName("");
            }
            if (showName && !y) {
              setCustomeFileName(default_ref_name_file_name);
            }
            if (!showName && y) {
              setCustomeFileName("");
            }
            if (!showName && !y) {
              setCustomeFileName(default_ref_file_name);
            }
          }}>Enable Custom File Name</Checkbox>
          <br />
          <br />
          <Row>
            <Col span={12}>
              <Input disabled={!showCustomFile} value={customFileName} addonAfter={`.pdf`} onChange={e => {
                setCustomeFileName(e.target.value)
              }} />
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }

  const UpdateFile = ({ form }) => {
    const { getFieldDecorator } = form;
    const [updating, setUpdating] = useState(false);

    let splitName = null;
    let suffix = "";
    let name = "";

    if (updateFileDetail) {
      // if file got exportLinks means it's google file
      if (updateFileDetail.exportLinks) {
        name = updateFileDetail.name;
      }
      else {
        splitName = updateFileDetail.name.split(".");
        suffix = "." + splitName[splitName.length - 1];
        splitName.pop();
        name = splitName.join(".");
      }
    }

    const handleOnClickUpdateFile = async () => {
      const formResult = await form.validateFields();
      setUpdating(true);
      const response = await updateDriveFile(session.authToken, {
        fileID: updateFileDetail.id,
        fileName: updateFileDetail.exportLinks ? formResult.updateFile : formResult.updateFile + suffix,
        starred: formResult.starred,
      });

      if (response.data.responseCode === 0) {
        setUpdating(false);
        setShowUpdateFileModal(false);
        message.success(response.data.message)

        setDriveRefetching(true);
        const driveResult = await getDrive(session.authToken, candidate.driveFolderID);
        setFiles(driveResult.data.data);
        setDriveRefetching(false);
      }
      else {
        setUpdating(false);
        message.error(response.data.message);
      }
    }

    return (
      <Modal
        centered={true}
        title="Edit Document"
        closable={false}
        visible={showUpdateFileModal}
        width={600}
        footer={[
          <Button
            disabled={updating}
            key="close" onClick={() => {
              setShowUpdateFileModal(false);
              setUpdateFileDetail(null);
            }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button
            key="update"
            type="primary"
            onClick={handleOnClickUpdateFile}
          >
            {updating ? <Icon type="loading" /> : <Icon type="check" />}
            Update
          </Button>
        ]}
      >
        <div>
          {
            updateFileDetail ?
              <div>
                <Form.Item label="Document Name">
                  {getFieldDecorator('updateFile', {
                    initialValue: name,
                    rules: [{ required: true, message: 'Please input document name!' }],
                  })(
                    <Input
                      suffix={updateFileDetail.exportLinks ? ".GoogleDocFile" : suffix}
                      placeholder="Document Name"
                      disabled={updating}
                    />
                  )}
                </Form.Item>

                <div style={{ marginTop: "-8px" }}>
                  {getFieldDecorator('starred', {
                    initialValue: updateFileDetail.starred,
                    valuePropName: 'checked'
                  })(<Checkbox disabled={updating}>{
                    <i style={{ color: "#bbb" }}>tick checkbox if document is CV type</i>
                  }</Checkbox>)}
                </div>
              </div>
              :
              null
          }
        </div>
      </Modal>
    )
  }
  const UpdateFileForm = Form.create({ name: 'update-file' })(UpdateFile);

  const UploadDocument = () => {
    const [uploadFiles, setUploadFiles] = useState([]);
    const [docUploading, setDocUploading] = useState(false);

    const handleOnClickUploadDocuments = async () => {
      setDocUploading(true);

      const fileList = [];
      for (const each of uploadFiles) {
        const file = await readFileAsync(each)
        fileList.push({
          name: each.name,
          type: each.type,
          data: file.replace(/data:.+,/, ""),
        })
      }

      await uploadDrive(
        session.authToken,
        {
          driveFolder: candidate.driveFolderID,
          files: fileList,
        }
      );
      setDocUploading(false);
      setShowUploadModal(false);
      message.success('Upload files finished');

      setDriveRefetching(true);
      const driveResult = await getDrive(session.authToken, candidate.driveFolderID);
      setFiles(driveResult.data.data);
      setDriveRefetching(false);
    }

    return (
      <Modal
        centered={true}
        title="Upload Documents"
        closable={false}
        visible={showUploadModal}
        width={525}
        footer={[
          <Button
            disabled={docUploading}
            key="close" onClick={() => {
              setShowUploadModal(false);
            }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button
            disabled={uploadFiles.length === 0}
            key="upload"
            type="primary"
            onClick={handleOnClickUploadDocuments}
          >
            {docUploading ? <Icon type="loading" /> : <Icon type="upload" />}
            Upload
          </Button>
        ]}
      >
        <Upload {...{
          accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
          multiple: true,
          onRemove: file => {
            setUploadFiles(uploadFiles.filter(i => i.uid !== file.uid));
          },
          beforeUpload: (_, fileList) => {
            setUploadFiles([...uploadFiles, ...fileList])
            return false;
          },
          uploadFiles,
        }}>
          <Button disabled={docUploading} >
            <Icon type="file" /> Select
          </Button>
          &nbsp;&nbsp;
          <i style={{ color: '#bbb' }}>Allowed file: image, pdf, doc, docx, xls, xlsx, ppt, pptx</i>
        </Upload>
        <br />
      </Modal>
    )
  }

  const fileColumnsWithoutStar = [
    {
      title: 'Name',
      width: '70%',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: file =>
        <div>
          <img
            src={file.iconLink}
            alt={file.name}
          />
          &nbsp;
          {file.name}
        </div>
    },
    {
      title: 'Date',
      width: '20%',
      key: 'date',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: file =>
        <div>
          {moment(file.createdTime).format("DD/MM/YY HH:mm")}
        </div>
    },
    {
      title: '',
      width: '5%',
      key: 'edit',
      render: file =>
        <div>
          <Tooltip title={"Edit"}>
            <FontAwesomeIcon
              onClick={() => {
                setUpdateFileDetail(file);
                setShowUpdateFileModal(true);
              }}
              style={{
                cursor: 'pointer',
              }} icon={faEdit} />
          </Tooltip>
        </div>
    },
    {
      title: '',
      width: '5%',
      key: 'view',
      render: file =>
        <div>
          <Tooltip title={"View"}>
            <FontAwesomeIcon
              onClick={() => {
                window.open(file.webViewLink, '_blank');
              }}
              style={{
                cursor: 'pointer',
              }} icon={faExternalLinkAlt} />
          </Tooltip>
        </div>
    },
  ]

  const fileColumns = [
    {
      title: '',
      width: '2%',
      key: 'star',
      render: file =>
        <div>
          {
            file.starred ?
              <Tooltip title={"CV Type"}>
                <FontAwesomeIcon style={{ color: "red" }} icon={faStar} />
              </Tooltip>
              :
              null
          }
        </div>
    },
    {
      title: 'Name',
      width: '68%',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: file =>
        <div>
          <img
            src={file.iconLink}
            alt={file.name}
          />
          &nbsp;
          {file.name}
        </div>
    },
    {
      title: 'Date',
      width: '20%',
      key: 'date',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: file =>
        <div>
          {moment(file.createdTime).format("DD/MM/YY HH:mm")}
        </div>
    },
    {
      title: '',
      width: '5%',
      key: 'edit',
      render: file =>
        <div>
          <Tooltip title={"Edit"}>
            <FontAwesomeIcon
              onClick={() => {
                setUpdateFileDetail(file);
                setShowUpdateFileModal(true);
              }}
              style={{
                cursor: 'pointer',
              }} icon={faEdit} />
          </Tooltip>
        </div>
    },
    {
      title: '',
      width: '5%',
      key: 'view',
      render: file =>
        <div>
          <Tooltip title={"View"}>
            <FontAwesomeIcon
              onClick={() => {
                window.open(file.webViewLink, '_blank');
              }}
              style={{
                cursor: 'pointer',
              }} icon={faExternalLinkAlt} />
          </Tooltip>
        </div>
    },
  ]

  return (
    loading ?
      <div>
        <p>Loading...</p>
        <Skeleton active />
      </div>
      :
      <div>
        <BackTop />
        <CVModal />
        <NewEventForm />
        <UploadDocument />
        <UpdateFileForm />

        <Modal
          zIndex={100}
          centered={true}
          title="Edit Candidate Notes"
          closable={false}
          visible={showNotesModal}
          width="90%"
          footer={[
            <Button disabled={notesLoading} key="cancel" onClick={() => {
              setShowNotesModal(false);
              if (candidate.notes) {
                setNotes(candidate.notes);
              } else {
                setNotes("");
              }
            }}>
              <Icon type="close" />
              Cancel
            </Button>,
            <Button key="edit" type="primary" onClick={() => {
              setNotesLoading(true);
              editCandidateNotes(
                session.authToken,
                { id: candidate.id, notes: notes }
              ).then(x => {

                if (x.data.responseCode === 0) {
                  dispatch({ type: "UPDATE_CANDIDATE_NOTES", payload: notes });
                  setShowNotesModal(false);
                  setNotesLoading(false);
                  message.success("candidate notes update successful");
                }
                else {
                  setShowNotesModal(false);
                  setNotesLoading(false);
                  setNotes(candidate.notes);
                  message.error(x.data.message);
                }

              });
            }}>
              {notesLoading ? <Icon type="loading" /> : <Icon type="check" />}
              Submit
            </Button>
          ]}
        >
          <CKEditor
            disabled={notesLoading}
            value={notes}
            data={notes}
            editor={Editor}
            config={editorConfig}
            onChange={(event, editor) => {
              const data = editor.getData();
              setNotes(data);
            }}
          />
        </Modal>

        <Row>
          <Col span={6}>
            <div style={{ marginRight: '5px' }}>
              <Card title={cardTitle(candidate)} bordered={true}>
                <div style={{ marginTop: '-25px' }}>
                  <React.Fragment>
                    <br />
                    <div><FontAwesomeIcon icon={faRegistered} />&nbsp;<b>Reference</b></div>
                    <div>{candidate.reference}</div>
                  </React.Fragment>

                  {
                    candidate.region && candidate.region !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<b>Region</b></div>
                        <div>{candidate.region}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.dob && candidate.dob !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b></div>
                        <div>{moment(candidate.dob).format('YYYY-MM-DD')}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.email !== "" || candidate.email1 !== "" || candidate.email2 !== "" ?
                      <React.Fragment>
                        <br />
                        <div><Icon type="mail" theme="filled" /> <b>Email</b></div>
                        {
                          candidate.email !== "" ?
                            <div>{candidate.email}</div>
                            :
                            null
                        }
                        {
                          candidate.email1 !== "" ?
                            <div>{candidate.email1}</div>
                            :
                            null
                        }
                        {
                          candidate.email2 !== "" ?
                            <div>{candidate.email2}</div>
                            :
                            null
                        }
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.mobile && candidate.mobile !== "" ?
                      <React.Fragment>
                        <br />
                        <div><Icon type="mobile" theme="filled" /> <b>Mobile</b></div>
                        <div>{candidate.mobile}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.location && candidate.location !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faMapMarkedAlt} /> <b>Location</b></div>
                        <div>{candidate.location}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.service && candidate.service !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faBriefcase} /> <b>Service</b></div>
                        <div>{candidate.service}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.position && candidate.position !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faUserTie} /> <b>Position</b></div>
                        <div>{candidate.position}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.wechat && candidate.wechat !== "" ?
                      <React.Fragment>
                        <br />
                        <div><Icon type="wechat" theme="filled" /> <b>Wechat</b></div>
                        <div>{candidate.wechat}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.whatsapp && candidate.whatsapp !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faPhoneVolume} /> <b>Whats App</b></div>
                        <div>{candidate.whatsapp}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.othercontact && candidate.othercontact !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faExclamationCircle} /> <b>Other Contact</b></div>
                        <div>{candidate.othercontact}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    candidate.source && candidate.source !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faInfoCircle} /> <b>Source</b></div>
                        <div>{candidate.source}</div>
                      </React.Fragment>
                      :
                      null
                  }

                </div>
              </Card>
            </div>
          </Col>

          <Col span={18}>
            <div style={{ marginLeft: '5px' }}>
              <Tabs
                tabBarExtraContent={<div>
                  Created By
                  &nbsp;&nbsp;
                  <CustomAvatar
                    colourCode={candidate.register.firstname.charAt(0).toLowerCase()}
                    char={`${candidate.register.firstname.charAt(0).toUpperCase()}${candidate.register.lastname.charAt(0).toUpperCase()}`}
                    charSize={14}
                    size={24}
                    src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${candidate.register.id}.jpeg`}
                  />
                  &nbsp;at&nbsp;<span>{moment(candidate.createdAt).format('DD/MM/YY')}</span>
                </div>}
                onChange={async (value) => {
                  setActiveTab(value);
                  if (value === "5") {
                    const template = await buildCVTemplate(candidate, true);
                    pdfMake.createPdf(template).getBuffer((buffer) => {
                      const dataUrl = URL.createObjectURL(new Blob([buffer], {
                        type: "application/pdf"
                      }));
                      setPdfURL(dataUrl);
                    });
                  }

                  // TODO: not sure why candidate.cvBody.description has been re-write like {text: 'xxx', ...}
                  const response = await getCandidate(session.authToken, props.id);
                  if (response.data.responseCode === 0) {
                    dispatch({ type: "INIT_CANDIDATE", payload: response.data.candidate });
                  }
                }}
                type="card"
              >
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faClipboard} /> Notes</span>
                } key="1">
                  <div style={flexCenterRight}>
                    <Button type="primary" onClick={() => {
                      setShowNotesModal(true);
                    }}><Icon type="edit" /> Edit Notes</Button>
                  </div>
                  <br />
                  {
                    candidate.notes && candidate.notes !== "" ?
                      parse(candidate.notes)
                      :
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  }
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faTasks} /> Events <Badge count={candidate.events.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
                } key="2">
                  <Row>
                    <Col span={8}>
                      <div>
                        <Select
                          value={eventType}
                          style={{ width: 220 }} onChange={(value) => { setEventType(value) }}
                        >
                          {eventTypeSelection}
                        </Select>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>
                        <Select
                          value={candidateContactList.contact}
                          style={{ width: 220 }} onChange={(value) => {
                            dispatch({
                              type: "SET_CANDIDATE_CONTACTS_LIST_SELECTION",
                              payload: value
                            })
                          }}>
                          {contactSelection}
                        </Select>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div style={flexCenterRight}>
                        <Button type="primary" onClick={() => {
                          setShowCreateEventModal(true)
                        }}><Icon type="plus-square" /> New Event</Button>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Spin spinning={eventReloading} indicator={<Icon type="loading" />}>
                    <CandidateEventsList
                      candidateID={props.id}
                      data={getEventsList(eventType, candidateContactList.contact, candidate.events)} />
                  </Spin>
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faFolderOpen} /> Docs</span>
                } key="3">
                  <Spin spinning={driveRefetching} indicator={<Icon type="loading" />}>

                    <Row>
                      <Col span={12}>
                        <Search
                          placeholder="Search"
                          onChange={e => setFileSearch(e.target.value)}
                          style={{ width: 200 }}
                        />
                      </Col>

                      <Col span={12}>
                        <div style={flexCenterRight}>
                          <Button type="primary" onClick={() => {
                            window.open(`https://drive.google.com/drive/folders/${candidate.driveFolderID}`, '_blank');
                          }}
                          >
                            <Icon type="google" /> Open Google Drive Folder
                          </Button>
                          &nbsp;&nbsp;
                          <Button type="primary" onClick={() => {
                            setShowUploadModal(true);
                          }}><Icon type="upload" /> Upload Documents</Button>
                        </div>
                      </Col>
                    </Row>

                    <br />

                    {
                      files.length > 0 ?
                        <Table
                          pagination={false}
                          columns={files.filter(i => i.starred).length > 0 ? fileColumns : fileColumnsWithoutStar}
                          dataSource={fileSearch === "" ?
                            files
                            :
                            files.filter(i => i.name.toLowerCase().includes(fileSearch.toLowerCase()))
                          }
                          rowKey="id"
                        />
                        :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }
                  </Spin>
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faEdit} /> Edit Candidate</span>
                } key="4">
                  <EditCandidateForm />
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faFileAlt} /> CV Preview</span>
                } key="5">
                  {
                    activeTab === "5" && pdfURL !== null ? (
                      <div>
                        {
                          candidate.cvBody && candidate.cvBody.work && candidate.cvBody.work.length > 0 ? (
                            <>
                            <Row>
                              <Col span={16} />
                              <Col span={8} style={flexCenterRight}>
                                <Button disabled={false} type="primary" key="create" onClick={() => {
                                  setShowCVModal(true);
                                }}>
                                  <Icon type="cloud-upload" />
                                  Generate Candidate CV
                                </Button>
                              </Col>
                            </Row>
                            <br />
                            <iframe
                              title="cv"
                              src={pdfURL}
                              style={{ width: '100%', height: '1000px', border: 0 }}
                            />
                            </>
                          ) : (
                            <Result
                              status="warning"
                              title="There is no enough candidate's information to generate CV, please fill in more details from Edit Candidate!"
                            />
                          )
                        }
                      </div>
                    ) : null
                  }
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faFileInvoice} /> Offers <Badge count={candidate.offers.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
                } key="7">
                  <OffersList offers={candidate.offers} type="candidate" />
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faFileInvoiceDollar} /> Invoices <Badge count={candidate.invoices.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
                } key="6">
                  <InvoicesList invoices={candidate.invoices} type="candidate" />
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
  );
}

export default Candidate;
